<template>
  <div class="flex w-full flex-col gap-24">
    <div class="flex w-full flex-col gap-16">
      <TypographyH1 class="font-semibold">
        {{ $t('health_actions.scheduling.select_doctor_title') }}
      </TypographyH1>
      <TypographyBody>
        {{ $t('health_actions.scheduling.select_doctor_description') }}
      </TypographyBody>
    </div>

    <div class="flex flex-col gap-16">
      <div class="flex flex-row justify-between items-center">
        <TypographyBody class="font-semibold">
          {{ $t('health_actions.scheduling.select_doctor_top_matches') }}
        </TypographyBody>
        <div
          class="flex flex-row gap-8 items-center"
          @click="openDoctorPreferenceModal"
        >
          <MagnifyingGlass />
          <TypographyBody class="text-blue-500 font-semibold cursor-pointer">
            {{ $t('health_actions.scheduling.select_doctor_search_doctors') }}
          </TypographyBody>
        </div>
      </div>
      <DoctorSkeletonLoader v-if="isFetchingProviders" :hasRadioButton="true" />

      <div v-else-if="getListOfDoctors.length > 0" class="flex flex-col gap-16">
        <div v-for="doctor in getListOfDoctors.slice(0, 20)" :key="doctor.name">
          <DoctorCardSelect :doctor="doctor" :canSelectMultiple="false" />
        </div>
      </div>

      <NoDoctorsFound
        v-else
        @open-zip-code-modal="openZipCodeModal"
        @close-zip-code-modal="closeZipCodeModal"
      />
    </div>
  </div>
</template>

<script>
import TypographyH1 from '~/components/common/Typography/H1.vue'
import TypographyBody from '~/components/common/Typography/Body.vue'
import DoctorCardSelect from './DoctorCard/DoctorCardSelect.vue'
import { mapGetters, mapActions } from 'vuex'
import { MagnifyingGlass } from '~/assets/svgs/index'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import NoDoctorsFound from './NoDoctorsFound.vue'
import doctorPreferencesMixin from './doctorPreferencesMixin'
import DoctorSkeletonLoader from './DoctorSkeletonLoader.vue'

export default {
  components: {
    TypographyH1,
    TypographyBody,
    DoctorCardSelect,
    MagnifyingGlass,
    NoDoctorsFound,
    DoctorSkeletonLoader,
  },
  mixins: [screenSizeMixin, doctorPreferencesMixin],
  computed: {
    ...mapGetters('scheduling', [
      'getListOfDoctors',
      'getDoctorPreferences',
      'isFetchingProviders',
      'zipCode',
    ]),
  },
  methods: {
    ...mapActions('scheduling', ['setDoctorPreferences']),
    openDoctorPreferenceModal() {
      this.$emit('open-doctor-preference-modal')
    },
    openZipCodeModal() {
      this.$emit('open-zip-code-modal')
    },
    closeZipCodeModal() {
      this.$emit('close-zip-code-modal')
    },
  },
}
</script>
